import React from 'react'
import { NavigationStackScreenComponent } from 'react-navigation-stack'
import styled from 'styled-components'
import { atlTheme } from '../../atlTheme'
import { ATLButton, ButtonTypeEnum } from '@appsimples/atlantica-react-native'
import { icons } from '../../constants/searchAssets'
import { Coordinator } from '../../navigation/coordinator/coordinator'
import { windowHeight } from '../../constants/dimensions'

const ImageDetailContainer = styled.div`
  background-color: ${atlTheme.ColorComplementary2};
  height: ${windowHeight - atlTheme.SpacingWide}px;
  display: flex;
  justify-content: center;
  align-content: center;
  width: 100%;
`

const CustomImage = styled.img`
  object-fit: contain;
`

export const ConstructionsImageDetail: NavigationStackScreenComponent = navigation => {
  // @ts-ignore
  const imageSource = navigation.route.params.imageSource

  return (
    <ImageDetailContainer>
      <CustomImage src={imageSource} />
    </ImageDetailContainer>
  )
}

ConstructionsImageDetail.navigationOptions = {
  headerLeft: () => (
    <ATLButton
      type={ButtonTypeEnum.label}
      title={''}
      horizontalMargin={-1}
      complementary
      buttonBaseProps={{
        icon: icons.chevronLeft,
        iconSize: atlTheme.SizeIconBase,
      }}
      onPress={Coordinator.goBack}
    />
  ),
  headerStyle: {
    backgroundColor: atlTheme.ColorComplementary2,
  },
  headerTitle: '',
}
